export default "__VITE_ASSET__DDZxWzIL__"